import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Typography from "@material-ui/core/Typography";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";
import { compose } from "recompose";
import { connect } from "react-redux";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import Checkbox from "@material-ui/core/Checkbox";
import { bindActionCreators } from "redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
import IconButton from "@material-ui/core/IconButton";
import * as Constants from "../../../helpers/Constants";

import { TableHead, TableTitle } from "../../common";

import * as CommunityActions from "../../actions/Communities";
import * as configActions from "../../actions/Config";
import * as Strings from "./strings";
import * as Functions from "../../../helpers/Functions";

const ROWS = [
  {
    id: "name",
    label: Strings.default.NAME,
    numeric: false,
    sortType: "string"
  },
  {
    id: "orgNumber",
    label: Strings.default.ORG_NUMBER,
    numeric: false,
    sortType: "string"
  },
  {
    id: "emailAddress",
    label: Strings.default.BILLING_AND_CONTACT_EMAIL,
    numeric: false,
    sortType: "string"
  },
  {
    id: "phoneNumber",
    label: Strings.default.CONTACT_NUMBER,
    numeric: false,
    sortType: "string"
  },
  {
    id: "firstName",
    label: Strings.default.CONTACT_FIRST_NAME,
    numeric: false,
    sortType: "string"
  },
  {
    id: "lastName",
    label: Strings.default.CONTACT_LAST_NAME,
    numeric: false,
    sortType: "string"
  },
  {
    id: "address",
    label: Strings.default.ADDRESS,
    numeric: false,
    sortType: "string"
  },
  {
    id: "postalNumber",
    label: Strings.default.ZIP_CODE,
    numeric: false,
    sortType: "string"
  },
  {
    id: "city",
    label: Strings.default.CITY,
    numeric: false,
    sortType: "string"
  },
  {
    id: "price",
    label: Strings.default.PRICE,
    numeric: false,
    sortType: "string"
  },
  {
    id: "createdAt",
    label: Strings.default.CREATED_AT,
    numeric: false,
    sortType: "string"
  },
  {
    id: "delete",
    label: "",
    numeric: false,
    sortType: null
  }
];

class CorporationTable extends Component {
  state = {
    page: 0,
    rowsPerPage: 10,
    orderBy: "name",
    order: "asc",
    sortType: "string"
  };

  desc(a, b, orderBy, sortType) {
    if (sortType === "integer") {
      return b[orderBy] - a[orderBy];
    }

    if (sortType === "boolean") {
      if (a[orderBy] && !b[orderBy]) {
        return 1;
      } else if (!a[orderBy] && b[orderBy]) {
        return -1;
      }

      return 0;
    }

    if (b[orderBy] < a[orderBy]) {
      return -1;
    } else if (b[orderBy] > a[orderBy]) {
      return 1;
    }

    return 0;
  }

  stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);

    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);

      if (order !== 0) {
        return order;
      }

      return a[1] - b[1];
    });

    return stabilizedThis.map(el => el[0]);
  }

  getSorting(order, orderBy, sortType) {
    return order === "desc"
      ? (a, b) => this.desc(a, b, orderBy, sortType)
      : (a, b) => -this.desc(a, b, orderBy, sortType);
  }

  onDelete(id) {
    //do delete
  }

  render(props) {
    const { classes, communities, onClick, user } = this.props;
    const { page, rowsPerPage, orderBy, order, sortType } = this.state;
    const startIndex = page * rowsPerPage;

    return (
      <div>
        <Paper className={classes.root}>
          <TableTitle
            iconLabel={Strings.default.NEW_CORPORATION}
            classes={classes}
            onIconClick={() => this.props.showCreateCorporationModal()}
            header={Strings.default.CUSTOMERS}
          />
          <Table className={classes.table} aria-labelledby={"tableTitle"}>
            <TableHead
              rows={ROWS}
              order={order}
              orderBy={orderBy}
              sortOn={(newOrderBy, newOrder, newSortType) =>
                this.setState({
                  orderBy: newOrderBy,
                  order: newOrder,
                  sortType: newSortType
                })
              }
            />
            <TableBody>
              {this.stableSort(
                communities.data,
                this.getSorting(order, orderBy, sortType)
              )
                .slice(startIndex, rowsPerPage + startIndex)
                .map(corporation => {
                  return (
                    <TableRow key={corporation.id} className={classes.row}>
                      <TableCell>{corporation.name}</TableCell>
                      <TableCell>{corporation.orgNumber}</TableCell>
                      <TableCell>{corporation.emailAddress}</TableCell>
                      <TableCell>{corporation.phoneNumber}</TableCell>
                      <TableCell>{corporation.firstName}</TableCell>
                      <TableCell>{corporation.lastName}</TableCell>
                      <TableCell>{corporation.address}</TableCell>
                      <TableCell>{corporation.postalNumber}</TableCell>
                      <TableCell>{corporation.city}</TableCell>
                      <TableCell>{corporation.price}</TableCell>
                      <TableCell>
                        {Functions.parseDate(new Date(corporation.createdAt))}
                      </TableCell>
                      <TableCell style={{ textAlign: "center", width: "1%" }}>
                        <FontAwesomeIcon
                          style={{
                            marginLeft: 24,
                            fontSize: 18,
                            cursor: "pointer"
                          }}
                          icon={faEdit}
                          color={"#000"}
                          onClick={() => onClick(corporation.id)}
                        />
                      </TableCell>
                      <TableCell style={{ textAlign: "center", width: "1%" }}>
                        <FontAwesomeIcon
                          icon={faTrash}
                          color={"#e57373"}
                          onClick={() => {
                            this.props.showAlert(
                              "Ta bort BRF",
                              "Är du säker på att du vill ta bort BRF:en? Detta kan inte göras ogjort.",
                              Constants.TWO_BUTTONS,
                              { title: "Nej", onPress: () => {} },
                              {
                                title: "Ja",
                                onPress: () =>
                                  this.props.tryDeleteCommunity(
                                    user.token,
                                    corporation.id
                                  )
                              }
                            );
                          }}
                          style={{ fontSize: 18, cursor: "pointer" }}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          <TablePagination
            component={"div"}
            count={communities.data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            labelRowsPerPage={"Rader per sida:"}
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} av ${count}`
            }
            onChangePage={(event, page) => this.setState({ page })}
            onChangeRowsPerPage={event =>
              this.setState({ rowsPerPage: event.target.value })
            }
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
          />
        </Paper>
      </div>
    );
  }
}

const styles = {
  root: {
    width: "100%",
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#fafafa"
    }
  },
  spacer: {
    flex: "1 1 100%"
  },
  actions: {
    color: "green"
  },
  title: {
    flex: "0 0 auto"
  }
};

CorporationTable.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps({ communities, user }) {
  return { communities, user };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...CommunityActions },
    dispatch
  );
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(CorporationTable);



// WEBPACK FOOTER //
// ./src/components/containers/CorporationTable/index.js